import { Pipe, PipeTransform } from '@angular/core';
import { PatientAssessmentStatus } from '../models/patient-assessment';

const assessmentStatusPipeText: { [key in PatientAssessmentStatus]: string } = {
  [PatientAssessmentStatus.ASSIGNED]: 'Assigned',
  [PatientAssessmentStatus.ATTEMPTED]: 'Attempted',
  [PatientAssessmentStatus.COMPLETED]: 'Completed',
  [PatientAssessmentStatus.DELETED]: 'Deleted',
  [PatientAssessmentStatus.DRAFT]: 'Draft',
  [PatientAssessmentStatus.ARCHIVED]: 'Archived'
};

@Pipe({ name: 'assessmentStatus' })
export class AssessmentStatusPipe implements PipeTransform {
  transform(value: PatientAssessmentStatus): string {
    return assessmentStatusPipeText[value] || '';
  }
}
